export default __webpack_public_path__ + "static/media/img5.5d154bd9.jpg";